import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const setAsDefaultHomePageButton = generateAutomationName("settings", ["set", "as", "default", "button"]);
export const alreadyAsDefaultTextContainer = generateAutomationName("settings", [
    "already",
    "as",
    "default",
    "text",
    "container",
]);
